import dynamicLocalization from "@/mixins/dynamic-localization";
import NewsletterTextBlock from "@/components/newsletter/blocks/Text";

export default {
  mixins: [dynamicLocalization],
  components: {
    NewsletterTextBlock,
  },
  props: {
    accentClass: { type: String, required: false },
    title: { type: Object, required: true },
    location: { type: Object, required: true },
    date: { type: Object, required: false },
    remarks: { type: Array, required: false },
    events: { type: Array, required: false },
  },
};
